import qs from 'qs'
import { api } from '$utils/apiRequester'

export const GET_PARTNER_REQUEST = 'GET_PARTNER_REQUEST'
export const GET_PARTNER_SUCCESS = 'GET_PARTNER_SUCCESS'
export const GET_PARTNER_FAILURE = 'GET_PARTNER_FAILURE'

export const LOAD_PARTNERS_REQUEST = 'LOAD_PARTNERS_REQUEST'
export const LOAD_PARTNERS_SUCCESS = 'LOAD_PARTNERS_SUCCESS'
export const LOAD_PARTNERS_FAILURE = 'LOAD_PARTNERS_FAILURE'

export const LIST_PARTNERS_PROJECTS_FAILURE = 'LIST_PARTNER_PROJECTS_FAILURE'
export const LIST_PARTNERS_PROJECTS_REQUEST = 'LIST_PARTNER_PROJECTS_REQUEST'
export const LIST_PARTNERS_PROJECTS_SUCCESS = 'LIST_PARTNER_PROJECTS_SUCCESS'

export const getPartner = id => ({
  types: [GET_PARTNER_REQUEST, GET_PARTNER_SUCCESS, GET_PARTNER_FAILURE],
  promise: () => api('ulule').get(`/partners/${id}`)
})

export const loadPartners = (params = {}) => {
  const query = {
    limit: 10,
    offset: 0,
    ...params
  }

  return {
    types: [LOAD_PARTNERS_REQUEST, LOAD_PARTNERS_SUCCESS, LOAD_PARTNERS_FAILURE],
    promise: () =>
      api('ulule').get(`/partners?${qs.stringify(query)}`, {
        withAccessToken: true
      }),
    query
  }
}

/**
 * listPartnerProjects fetches a paginated list of projects partnered by the given user
 * (e.g. have a partnership link with the partner/user)
 * @param {string} slug of the partner
 * @return {object} redux action
 */
export const listPartnerProjects = ({
  extraFields = null,
  limit = 9,
  next,
  partnerSlug,
  withAccessToken = false,
  isWinner = false,
  status = null
}) => {
  // If `next` exists if true use it alone
  // else `limit` is always here then => check is `isWinner` is true, if true use it else empty string => check if `status` is declared, if true put it else empty string

  const query = `/partners/${partnerSlug}/projects${
    next
      ? `${next}`
      : `?limit=${limit}${extraFields ? `&extra_fields=${extraFields}` : ''}${isWinner ? '&is_winner=true' : ''}${
          status ? `&status=${status}` : ''
        }`
  }`

  return {
    types: [LIST_PARTNERS_PROJECTS_REQUEST, LIST_PARTNERS_PROJECTS_SUCCESS, LOAD_PARTNERS_FAILURE],
    promise: () =>
      api('ulule').get(query, {
        withAccessToken
      })
  }
}
